import { Routes, Route } from 'react-router-dom';
import Layout from './app/Layout';

// Pages
import HomePage from './app/page';
import QuickStartPage from './app/quick-start/page';
import ExamplesPage from './app/examples/page';
import WorkspacePage from './app/workspace/page';
import TimelinePage from './app/timeline/page';
import AIModelsPage from './app/ai-models/page';
import ControlNetPage from './app/controlnet/page';
import ExampleStudioPage from './app/example-studio/page';

// Image Models
import GoogleImagenPage from './app/images-models/google-imagen/page';
import QwenImagePage from './app/images-models/qwen-image/page';
import RunwayImagePage from './app/images-models/runway-image/page';
import FluxProPage from './app/images-models/flux-pro/page';
import WanImagePage from './app/images-models/wan-image/page';
import SeeDream4Page from './app/images-models/see-dream4/page';

// Video Models
import GoogleVeoPage from './app/videos-models/google-veo/page';
import RunwayVideoPage from './app/videos-models/runway-video/page';
import PikaVideoPage from './app/videos-models/pika-video/page';
import HailuoVideoPage from './app/videos-models/hailuo-video/page';
import WanVideoPage from './app/videos-models/wan-video/page';
import PixverseLipsyncPage from './app/videos-models/pixverse-lipsync/page';
import VeedLipsyncPage from './app/videos-models/veed-lipsync/page';

// Speech Models
import GeminiSpeechPage from './app/speech-models/gemini-speech/page';
import OpenAISpeechPage from './app/speech-models/openai-speech/page';

// Music Models
import SunoPage from './app/music-models/suno/page';
import GoogleLyriaPage from './app/music-models/google-lyria/page';

// Sound Effects Models
import ElevenLabsSoundEffectsPage from './app/sound-effects-models/elevenlabs-sound-effects/page';

// Support
import SupportPage from './app/support/page';
import FAQPage from './app/faq/page';

// Error Pages
import NotFoundPage from './app/not-found';

function App() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/quick-start" element={<QuickStartPage />} />
                <Route path="/examples" element={<ExamplesPage />} />
                <Route path="/workspace" element={<WorkspacePage />} />
                <Route path="/timeline" element={<TimelinePage />} />
                <Route path="/ai-models" element={<AIModelsPage />} />
                <Route path="/controlnet" element={<ControlNetPage />} />
                <Route path="/example-studio" element={<ExampleStudioPage />} />

                {/* Image Models */}
                <Route path="/images-models/google-imagen" element={<GoogleImagenPage />} />
                <Route path="/images-models/qwen-image" element={<QwenImagePage />} />
                <Route path="/images-models/runway-image" element={<RunwayImagePage />} />
                <Route path="/images-models/flux-pro" element={<FluxProPage />} />
                <Route path="/images-models/wan-image" element={<WanImagePage />} />
                <Route path="/images-models/see-dream4" element={<SeeDream4Page />} />

                {/* Video Models */}
                <Route path="/videos-models/google-veo" element={<GoogleVeoPage />} />
                <Route path="/videos-models/runway-video" element={<RunwayVideoPage />} />
                <Route path="/videos-models/pika-video" element={<PikaVideoPage />} />
                <Route path="/videos-models/hailuo-video" element={<HailuoVideoPage />} />
                <Route path="/videos-models/wan-video" element={<WanVideoPage />} />
                <Route path="/videos-models/pixverse-lipsync" element={<PixverseLipsyncPage />} />
                <Route path="/videos-models/veed-lipsync" element={<VeedLipsyncPage />} />

                {/* Speech Models */}
                <Route path="/speech-models/gemini-speech" element={<GeminiSpeechPage />} />
                <Route path="/speech-models/openai-speech" element={<OpenAISpeechPage />} />

                {/* Music Models */}
                <Route path="/music-models/suno" element={<SunoPage />} />
                <Route path="/music-models/google-lyria" element={<GoogleLyriaPage />} />

                {/* Sound Effects Models */}
                <Route path="/sound-effects-models/elevenlabs-sound-effects" element={<ElevenLabsSoundEffectsPage />} />

                {/* Support */}
                <Route path="/support" element={<SupportPage />} />
                <Route path="/faq" element={<FAQPage />} />

                {/* 404 */}
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Layout>
    );
}

export default App;
